// extracted by mini-css-extract-plugin
module.exports = {"ShadowProps":"ShadowProps_ShadowProps__1jDtq"};